import type { AppMode, Nullish } from '@iheartjane/types';

import type { UserLocation } from '@jane/shared/types';

// Product reviews are not allowed in Ohio
const isInOhio = (userLocation: UserLocation | null) =>
  Boolean(userLocation?.cityState?.endsWith(', OH'));

export const productReviewsEnabled = (
  appMode: AppMode,
  userLocation: UserLocation | null,
  currentStore?: Nullish<{
    force_disable_reviews?: Nullish<boolean>;
    product_reviews_enabled?: boolean;
  }>
): boolean => {
  if (isInOhio(userLocation)) return false;
  if (!currentStore) return true;

  if (appMode === 'default') return !currentStore.force_disable_reviews;

  return Boolean(currentStore.product_reviews_enabled);
};
